import { render, staticRenderFns } from "./material-credentials.vue?vue&type=template&id=993c26dc&scoped=true&"
import script from "./material-credentials.vue?vue&type=script&lang=js&"
export * from "./material-credentials.vue?vue&type=script&lang=js&"
import style0 from "./material-credentials.vue?vue&type=style&index=0&id=993c26dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993c26dc",
  null
  
)

export default component.exports